import { Box, Button, ButtonGroup, Text } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { AdaptedSelect, CheckboxControl, Optional } from "../components/Form";
import { useSpecialitiesQuery } from "../graphql";

export interface IApproveDoctorValues {
  specialityId: string;
  approvoAsSpeciality: boolean;
}

interface IApproveDoctorForm {
  onSubmit: (values: IApproveDoctorValues) => void;
  initialValues?: Optional<IApproveDoctorValues>;
}

export const ApproveDoctorForm: React.FC<IApproveDoctorForm> = ({
    onSubmit,
    initialValues
}) => {
    const validate = (values) => {
        const errors: { [key: string]: string } = {};

        if (values.approvoAsSpeciality && !values.specialityId) {
            errors.specialityId = "Fushë e detyruar";
        }

        return errors;
    };

    const { data, loading } = useSpecialitiesQuery();

    return (
        <Form
            onSubmit={ onSubmit }
            validate={ validate }
            initialValues={ initialValues }
            render={ ({
                handleSubmit,
                form,
                errors,
                submitting,
                pristine,
                values
            }) => (
                <Box as="form" p={ 2 } onSubmit={ handleSubmit }>
                    <CheckboxControl name="approvoAsSpeciality">
                        Aprovoje si specialist?
                    </CheckboxControl>
                    <Field
                        name="specialityId"
                        component={ AdaptedSelect }
                        label="Specialiteti"
                        isDisabled={ loading || !values.approvoAsSpeciality }
                    >
                        { data?.specialities.map((speciality) => (
                            <option value={ speciality.id }>{ speciality.name }</option>
                        )) }
                    </Field>

                    <ButtonGroup spacing={ 4 }>
                        <Button
                            isLoading={ submitting }
                            loadingText="Duke dërguar"
                            variantColor="teal"
                            type="submit"
                        >
                            Aprovo kërkesën
                        </Button>
                        <Button
                            variantColor="teal"
                            variant="outline"
                            onClick={ form.reset }
                            isDisabled={ submitting || pristine }
                        >
                            Pastro
                        </Button>
                    </ButtonGroup>
                </Box>
            ) }
        />
    );
};
